<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">¡Sigue avanzando!</h1>
    </div>
    
    @for (config of dataInputs(); track $index) {
        <app-input
            class="w-full"
            [config]="config"
            (submitValue)="handleValue($event)"
        ></app-input>
    }

    <button class="btn-primary mb-6" [disabled]="!form.valid">
        Continuar
    </button>
</form>